import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { organizationDTO } from 'src/app/models/providersDTO';
import { Router } from '@angular/router';
import { PersistenceService, StorageType } from 'angular-persistence';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ResultsService } from 'src/app/services/results.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-ui-header',
  templateUrl: './ui-header.component.html',
  styleUrls: ['./ui-header.component.css']
})
export class UiHeaderComponent implements OnInit {
  public orgDetails: organizationDTO = new organizationDTO();
  public headerProviderSearch: string;
  public TempgridData: any[] = [];
  interval:any;
  latitude: string;
  longitude: string;
  contentPath = localStorage.getItem('ContentPath');

  constructor(private commonService: CommonService, private router: Router,
    private persistenceService: PersistenceService, private formBuilder: FormBuilder,
    private resultsService: ResultsService, private spinner: NgxSpinnerService, ) {
      this.commonService.getOrganizationDetails().then((formdata) => {
        this.persistenceService.set('currentorgDetails', formdata[0], { type: StorageType.SESSION });
        this.orgDetails = persistenceService.get('currentorgDetails', StorageType.SESSION);
      });
  }  

  ngOnInit() {  

    this.refreshData();
    this.interval = setInterval(() => { 
        this.refreshData(); 
    }, 60000);

    $(document).ready(function() {     
      $('#text_bigger,#t_bigger').click(function()
      {
        var curr_font_size = $("body").css('font-size');
        var new_font_size = parseFloat(curr_font_size) + 2;
        if(new_font_size < 32){
          $('body').animate({fontSize: new_font_size+'px'}, 250);
        }        
      });
      $('#text_default,#t_default').click(function()
      {
        $('body').animate({fontSize: 15}, 250);              
      });
      $('#text_smaller,#t_smaller').click(function()
      {
        var curr_font_size = $("body").css('font-size');
        var new_font_size = parseFloat(curr_font_size) - 2;
        if(new_font_size > 6){
          $('body').animate({fontSize: new_font_size+'px'}, 250);
        } 
      });

      var search = document.getElementById("enter");
      search.addEventListener("keyup", function(event) {
        if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("button-addon3").click();
        }
      });
  });             
  }

  async refreshData()
  {
    this.commonService.getOrganizationDetails().then((formdata) => {
      this.persistenceService.set('currentorgDetails', formdata[0], { type: StorageType.SESSION });
      this.orgDetails = formdata[0];
    });

    this.contentPath=localStorage.getItem('ContentPath');
    
    await this.resultsService.getNetworkZipCodes().subscribe((data: any[]) => {
      this.TempgridData = data;
    });
    
  }

  SearchProviders() {
    if(this.headerProviderSearch != undefined && this.headerProviderSearch != "")
    {
      this.spinner.show(); 
      var loc = this.TempgridData.filter(locaddress => 
        locaddress.zipCode.toLocaleLowerCase().indexOf(this.headerProviderSearch.toLocaleLowerCase()) == 0
        );
      
        if(loc != undefined && loc != null && loc.length > 0)
        {
          this.resultsService.getLatlons(loc[0].location).then((formdata) => {          
            if(formdata!=undefined && formdata.length>0)
            {
              this.latitude = formdata[0].latitude;
              this.longitude = formdata[0].longitude; 
            }
            else{
              this.latitude = "0";
              this.longitude = "0"; 
            }                   
          });
  
          setTimeout(() => {
          if((this.latitude != undefined && this.latitude != null && this.latitude != ""))
          {
            this.headerProviderSearch="";
            this.router.navigate(['/results'], { queryParams: {sp:"",locsearch:loc[0].location,latitude: this.latitude, longitude: this.longitude, _planSearch: "", _action: "all" } });
          }
          else{
            this.spinner.hide();
            Swal.fire({            
              title: 'Something went wrong!',
              text:'Please try again with valid location!',
              icon: 'error'
            })
          } 
        },2000);  
        }          
        else{
          this.router.navigate(['/providersearch'], { queryParams: { sp: this.commonService.getSearchValue(this.headerProviderSearch), _action: "all"} });
          this.headerProviderSearch="";
        }
      // this.router.navigate(['/results'], { queryParams: { sp: this.headerProviderSearch ,_action:"all"} });
      // this.headerProviderSearch = "";
    }
  }
}